import React from 'react';

export const icons: { [key: string]: string[][] } = {
  eu: [
    [
      'https://websiteoss.ecoflow.com/upload/image/1773727721855/light.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747172389/camera.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011772/drone.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012439/laptop.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747011563/drill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011335/circular_saw.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747010852/angle_grinder.png',
    ],
  ],
  es: [
    [
      'https://websiteoss.ecoflow.com/upload/image/1773727721855/light.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747172389/camera.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011772/drone.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012439/laptop.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747011563/drill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011335/circular_saw.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747010852/angle_grinder.png',
    ],
  ],
  it: [
    [
      'https://websiteoss.ecoflow.com/upload/image/1773727721855/light.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747172389/camera.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011772/drone.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012439/laptop.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747011563/drill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011335/circular_saw.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747010852/angle_grinder.png',
    ],
  ],
  fr: [
    [
      'https://websiteoss.ecoflow.com/upload/image/1773727721855/light.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747011563/drill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011335/circular_saw.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747010852/angle_grinder.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747011104/audio.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012668/projector.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747528730/coffee_machine.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012439/laptop.png',
    ],
  ],
  de: [
    [
      'https://websiteoss.ecoflow.com/upload/image/1773727721855/light.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747011104/audio.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012668/projector.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747012932/water_heater.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012209/Fish%20tank.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747013148/well_pump.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747011563/drill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011335/circular_saw.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747010852/angle_grinder.png',
    ],
  ],
  uk: [
    [
      'https://websiteoss.ecoflow.com/upload/image/1773727721855/light.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747012932/water_heater.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012209/Fish%20tank.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747013148/well_pump.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747172389/camera.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011772/drone.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012439/laptop.png',
    ],
  ],
  nl: [
    [
      'https://websiteoss.ecoflow.com/upload/image/1773727721855/light.png',
      'https://websiteoss.ecoflow.com/upload/image/1773750579789/electric_grill.png',
      'https://websiteoss.ecoflow.com/upload/image/1773727830441/kettle.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747012932/water_heater.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012209/Fish%20tank.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747013148/well_pump.png',
    ],
    [
      'https://websiteoss.ecoflow.com/upload/image/1773747172389/camera.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747011772/drone.png',
      'https://websiteoss.ecoflow.com/upload/image/1773747012439/laptop.png',
    ],
  ],
};
export const images: { [key: string]: { pc: string, h5: string }[] } = {
  fr: [
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180388/01.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742094/m01.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180730/03.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742477/m03.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180534/04.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742651/m04.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901181324/05.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742887/m05.jpg',
    },
  ],
  de: [
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180388/01.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742094/m01.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180534/04.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742651/m04.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901181135/06.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901743079/m06.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180730/03.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742477/m03.jpg',
    },
  ],
  nl: [
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180388/01.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742094/m01.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901181135/06.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901743079/m06.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180922/02.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742258/m02.jpg',
    },

  ],
  eu: [
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180388/01.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742094/m01.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180922/02.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742258/m02.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180730/03.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742477/m03.jpg',
    },
  ],
  es: [
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180388/01.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742094/m01.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180922/02.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742258/m02.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180730/03.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742477/m03.jpg',
    },
  ],
  it: [
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180388/01.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742094/m01.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180922/02.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742258/m02.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901180730/03.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901742477/m03.jpg',
    },
  ],
  uk: [
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901676210/uk-011.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901676774/uk-m1.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901676018/uk-022.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901676586/uk-m2.jpg',
    },
    {
      pc: 'https://websiteoss.ecoflow.com/upload/image/1773901675717/uk-033.jpg',
      h5: 'https://websiteoss.ecoflow.com/upload/image/1773901676408/uk-m3.jpg',
    },
  ],

};
